import React from "react";
import { connect } from "react-redux";
import './style.css';
import ReactComponent from "../ReactComponent";
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Tabs } from 'antd';
import AttendanceDailyRecord  from "./AttendanceDailyRecord";
import AttendanceMonthlyRecord from "./AttendanceMonthlyRecord";
import AttendanceYearlyRecord from "./AttendanceYearlyRecord";

class ResultsReport extends ReactComponent {

  state = {
    tabIndex: "selectAttendanceDailyRecord",
    filters: {},
    data: []
  }

  componentWillMount() {
    if (sessionStorage.getItem("tabActiveIndex")) {
      this.setState({
        tabIndex: sessionStorage.getItem("tabActiveIndex")
      })
    }
  }

  actions = {}

  changeTabIndex = value => {
    this.setState({
      tabIndex: value
    })
    sessionStorage.setItem("tabActiveIndex", value)
  }

  render () {
    const TabPane = Tabs.TabPane;
    return (
      <div className="app-module-item">
        <Tabs activeKey={this.state.tabIndex}
          animated={false}
          onChange={this.changeTabIndex}>
          {/* <TabPane tab="日报" key="selectAttendanceDailyRecord" ><AttendanceDailyRecord /></TabPane> */}
          <TabPane tab="月报" key="selectAttendanceMonthlyRecord"><AttendanceMonthlyRecord /></TabPane>
          <TabPane tab="年报" key="selectAttendanceYearlyRecord"><AttendanceYearlyRecord /></TabPane>
        </Tabs>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {

  }
}

const mapDispatchToProps = {

}

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ResultsReport));



// WEBPACK FOOTER //
// ./src/routes/Attendance/ResultsReport.js